import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  CardHeader,
  Media,
  Input,
  Badge,
} from "reactstrap";
import {
  faAngleDown,
  faAngleUp,
  faCheck,
  faCog,
  faHome,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Card,
  Table,
  Button,
  ButtonGroup,
  Breadcrumb,
} from "@themesberg/react-bootstrap";

import SpinDiv from "../components/SpinDiv";
import AddTermination from "./AddTermination";
import moment from "moment";
import { throttle,debounce } from "./debounce";
import 'antd/dist/antd.css';
import { Pagination } from 'antd';
import EditTermination from "./EditTermination";
import { getTerminations, getTerminationTypes } from "../../services/terminationService";

export class TerminationIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "", 
      page: 1,
      rows: 10,
      loading: false,
      employees2:[],
      employees: [],
      terminations:[],
      termination_types:[],
      total: 0,
      

    

    };
    this.searchDebounced = debounce(this.searchTerminations, 500);
    this.searchThrottled = throttle(this.searchTerminations, 500);
  }

  componentDidMount() {
    this.searchTerminations();
  }

  

  searchTerminations = () => {
    const { page, rows, search, terminations } = this.state;
    this.setState({ loading: true });
    getTerminations({ page, rows, search, terminations }).then(

      (res) => {
        this.setState({
          terminations: res.terminations.data,
          termination_types:res.termination_types,
          employees: res.employees,
          employees2:res.employees2,
          page: res.terminations.current_page,
          total: res.terminations.total,
          loading: false,
        });
      },
      (error) => {
        this.setState({ loading: false });
      }
    );
  };

 

  onChange = (e, state) => {
    this.setState({ [state]: e });
  };

  onPage = async (page,rows) => {
    await this.setState({page,rows});
    await this.getTerminations();
  }
  
  handleSearch = event => {
    this.setState({ search: event.target.value }, () => {
      if(this.state.search < 5){
        this.searchThrottled(this.state.search);
      }else{
        this.searchDebounced(this.state.search);
      }
    
    });
  };
  
  toggleAddTermination = () => {
    this.setState({ addTermination: !this.state.addTermination });
    this.searchTerminations();
  }

  toggleEditTermination = (editTermination) => {
    this.setState({ editTermination});
    this.searchTerminations();
   
  };
  toggleCloseTermination=(editTermination)=>{
    this.setState({ editTermination: !this.state.editTermination });
  }

 

  toggleTermination = () => {
    this.setState({ Termination: !this.state.Termination });
    this.searchTerminations();
  }



  
  



  




  

  render() {
    const { employees, employees2, terminations, termination_types, total, page, rows, search, loading,addTermination, editTermination } = this.state;
    
    return (
      <>
       
        
        {addTermination && (
          <AddTermination
            saved={this.searchTerminations}
            employees={employees}
            termination_types={termination_types}
            toggle={this.toggleAddTermination}
            
          />
        )}

        {editTermination && (
          <EditTermination
            saved={this.searchTerminations}
            employees={employees2}
            termination_types={termination_types}
            termination={editTermination}
            toggle={this.toggleCloseTermination}
          />
        )}

        
        {/* {deleteTraining && (
          <DeleteTraining
            saved={this.searchTerminations}
            deleteTraining={deleteTraining}
            toggle={this.toggleCloseDelete}
          />
        )} */}

      
       
        {loading && <SpinDiv text={"Loading..."} />}

        <Row style={{}}>
          <Col lg="12">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
              <div className="d-block mb-4 mb-md-0">
                <Breadcrumb
                  listProps={{
                    className: " breadcrumb-text-dark text-primary",
                  }}
                >
                  <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                  <Breadcrumb.Item href="#users">Terminations</Breadcrumb.Item>
                </Breadcrumb>
              </div>
              <div className="btn-toolbar mb-2 mb-md-0">
                <ButtonGroup>
                  <Button variant="outline-primary" size="sm" onClick={() => this.toggleAddTermination()}>
                    Create Termination
                  </Button>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => {this.props.history.push('/terminationtypes')}}
                  >
                    Termination Types
                  </Button>
              
                  {/* <Button variant="outline-primary" size="sm">
                    Export
                  </Button> */}
                </ButtonGroup>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg="8">
          <h5 className="mb-0">Terminations
          <span style={{color: '#aaa', fontSize: 14, fontWeight: 'normal'}}> ({total})</span></h5>
          </Col>
          <Col lg="4" className="">
            <div style={{ display: "flex" }}>
              <Input
                placeholder="Search..."
                autoFocus
                id="show"
                value={search}
                style={{ maxHeight: 45, marginRight: 5, marginBottom: 10 }}
                onChange={this.handleSearch}
                
              />
            </div>
          </Col>
        </Row>

        <Card border="light" className="shadow-sm mb-4">
          <Card.Body className="pb-0">
            <Table
              responsive
              className="table-centered table-nowrap rounded mb-0"
            >
              <thead className="thead-light">
                <tr>
                  <th className="border-0">Employees</th>
                  <th className="border-0">Notice Date</th>
                  <th className="border-0">Termination Date</th>
                  <th className="border-0">actions</th>
                </tr>
              </thead>
              <tbody>
                
                {terminations.map((termination, key) => {
               
                  return (
                    <tr >
                     <th scope="row">
                      <td>
                        <Media className="align-items-center">
                          <a
                            className="avatar rounded-circle mr-3"
                            href="#p"
                            onClick={(e) => e.preventDefault()}
                          >
                            <img
                              style={{
                                maxHeight: 50,
                                maxWidth: 50,
                                borderRadius: '100%',
                              }}
                              alt="..."
                              src={
                                termination.image ||
                                require("../../assets/img/brand/user.jpg")
                              }
                            />
                           
                          </a>
                          </Media>
                        </td>
                        <td>
                        <span style={{fontWeight:"bold",textTransform:"capitalize"}}>{termination.name}</span>
                      </td>
                        
                      </th>
                      <td>{moment(termination.notice_date).format('MMM D, YYYY')}</td>
                        
                    
                      <td>{moment(termination.termination_date).format('MMM D, YYYY')}</td>
      
                    
                      <td>
                        
                        <ButtonGroup>
                          <Button variant="outline-primary" style={{fontWeight:"bold",textTransform:"capitalize"}} onClick={() => this.toggleEditTermination(termination)} size="sm">view</Button>
                          
                        </ButtonGroup>
                      </td>

                      
                      
                    </tr>
                  );
                })}
              </tbody>
             
            </Table>
            <Row>
              <Col md={12} style={{fontWeight:"bold",paddingTop:3}}>
              {terminations.length<1&&
                <div style={{color: '#ccc', alignSelf: 'center', padding: 10, fontSize: 13}}>
                  <i className="fa fa-ban" style={{marginRight: 5}}/>
                  No Terminations
                </div>}
              {terminations.length > 0 && <Pagination
                  total={total}
                  showTotal={total => `Total ${total} terminations for all Employees`}
                  onChange={this.onPage}
                  pageSize={rows}
                  current={page}
                />}
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </>
    );
  }
}

export default TerminationIndex;
